/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {Alert} from './alert';
import {MultiAlertService} from './providers/multi-alert-service';
export class AlertsPager implements OnInit, OnDestroy {
private multiAlertServiceChanges: Subscription;
/**
 * Input/Output to support two way binding on current alert instance
 * @param {?} alert
 * @return {?}
 */
set currentAlert(alert: Alert) {
        if (alert) {
            this.multiAlertService.currentAlert = alert;
        }
    }
/**
 * @return {?}
 */
get currentAlert() {
        return this.multiAlertService.currentAlert;
    }

     currentAlertChange = new EventEmitter<Alert>(false);
/**
 * Input/Output to support two way binding on current alert index
 * @param {?} index
 * @return {?}
 */
set currentAlertIndex(index: number) {
        this.multiAlertService.current = index;
    }
/**
 * @return {?}
 */
get currentAlertIndex() {
        return this.multiAlertService.current;
    }

     currentAlertIndexChange = new EventEmitter<number>();
/**
 * @param {?} multiAlertService
 */
constructor(public multiAlertService: MultiAlertService) {}
/**
 * @return {?}
 */
ngOnInit() {
        this.multiAlertServiceChanges = this.multiAlertService.changes.subscribe((index) => {
            this.currentAlertIndexChange.emit(index);
            this.currentAlertChange.emit(this.multiAlertService.activeAlerts[index]);
        });
    }
/**
 * @return {?}
 */
pageUp() {
        this.multiAlertService.next();
    }
/**
 * @return {?}
 */
pageDown() {
        this.multiAlertService.previous();
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.multiAlertServiceChanges.unsubscribe();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{selector: "clr-alerts-pager", template: `
  <div class="alerts-pager-control">
      <div class="alerts-page-down">
          <button class="alerts-pager-button" (click)="pageDown()">
              <clr-icon shape="caret left"></clr-icon>
          </button>
      </div>
      <div class="alerts-pager-text">
          {{this.multiAlertService.current+1}} / {{this.multiAlertService.count}}
      </div>
      <div class="alerts-page-up">
          <button class="alerts-pager-button" (click)="pageUp()">
              <clr-icon shape="caret right"></clr-icon>
          </button>
      </div>
  </div>
`, host: {"[class.alerts-pager]": "true"}}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MultiAlertService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'currentAlert': [{ type: Input, args: ["clrCurrentAlert", ] },],
'currentAlertChange': [{ type: Output, args: ["clrCurrentAlertChange", ] },],
'currentAlertIndex': [{ type: Input, args: ["clrCurrentAlertIndex", ] },],
'currentAlertIndexChange': [{ type: Output, args: ["clrCurrentAlertIndexChange", ] },],
};
}

function AlertsPager_tsickle_Closure_declarations() {
/** @type {?} */
AlertsPager.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AlertsPager.ctorParameters;
/** @type {?} */
AlertsPager.propDecorators;
/** @type {?} */
AlertsPager.prototype.multiAlertServiceChanges;
/** @type {?} */
AlertsPager.prototype.currentAlertChange;
/** @type {?} */
AlertsPager.prototype.currentAlertIndexChange;
/** @type {?} */
AlertsPager.prototype.multiAlertService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
